"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _default = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      padding: 0
    }, (0, _defineProperty2.default)(_root, ['&:hover', '&:hover.Mui-checked'], {
      backgroundColor: 'transparent'
    }), (0, _defineProperty2.default)(_root, '&.Mui-focusVisible', {
      outline: "".concat(theme.palette.sapphire[500], " dashed 2px"),
      outlineOffset: '2px'
    }), _root),
    icon: {
      borderRadius: 24,
      width: 24,
      height: 24,
      boxShadow: "inset 0 0 0 1px ".concat(theme.palette.neutral.fog),
      backgroundColor: theme.palette.common.white,
      backgroundImage: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      'input:hover ~ &': {
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.sapphire[500])
      },
      'input:disabled ~ &': {
        backgroundColor: theme.palette.common.white,
        boxShadow: "inset 0 0 0 1px ".concat(theme.palette.neutral.stainless)
      }
    },
    iconRed: {
      backgroundColor: theme.palette.cardinal[50],
      boxShadow: "inset 0 0 0 1px ".concat(theme.palette.cardinal[500]),
      'input:hover ~ &': {
        backgroundColor: theme.palette.common.white,
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.cardinal[500])
      },
      'input:active ~ &': {
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.cardinal[900])
      },
      'input:disabled ~ &': {
        backgroundColor: theme.palette.common.white,
        boxShadow: "inset 0 0 0 1px ".concat(theme.palette.neutral.stainless)
      }
    },
    checkedIcon: {
      backgroundColor: theme.palette.sapphire[500],
      boxShadow: "inset 0 0 0 2px ".concat(theme.palette.sapphire[500], ", inset 0 0 0 6px ").concat(theme.palette.common.white),
      'input:hover ~ &': {
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.sapphire[700], ", inset 0 0 0 6px ").concat(theme.palette.common.white)
      },
      'input:active ~ &': {
        backgroundColor: theme.palette.sapphire[700],
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.sapphire[700], ", inset 0 0 0 6px ").concat(theme.palette.common.white)
      },
      'input:disabled ~ &': {
        backgroundColor: theme.palette.sapphire[100],
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.sapphire[100], ", inset 0 0 0 6px ").concat(theme.palette.common.white)
      }
    },
    checkedIconRed: {
      backgroundColor: theme.palette.cardinal[500],
      boxShadow: "inset 0 0 0 2px ".concat(theme.palette.cardinal[500], ", inset 0 0 0 6px ").concat(theme.palette.common.white),
      'input:hover ~ &': {
        backgroundColor: theme.palette.cardinal[500],
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.cardinal[700], ", inset 0 0 0 6px ").concat(theme.palette.common.white)
      },
      'input:active ~ &': {
        backgroundColor: theme.palette.cardinal[900],
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.cardinal[900], ", inset 0 0 0 6px ").concat(theme.palette.common.white)
      },
      'input:disabled ~ &': {
        backgroundColor: theme.palette.cardinal[100],
        boxShadow: "inset 0 0 0 2px ".concat(theme.palette.cardinal[100], ", inset 0 0 0 6px ").concat(theme.palette.common.white)
      }
    }
  };
}, {
  name: 'PdsRadio'
});

exports.default = _default;
